// extracted by mini-css-extract-plugin
module.exports = {"section":"k_KOSnI","inner":"k_1WIZJ","wrap":"k_3XPqS","branchList":"k_2r42X","button":"k_3a0ds","picture":"k_1-na8","playButton":"k_H6j5_"};